import React, { useEffect, useRef } from 'react'
import * as monaco from 'monaco-editor'
import { FaRegCopy } from '@react-icons/all-files/fa/FaRegCopy'

interface ReadOnlyEditorProps {
  code: string
  language?: string
}

const CampaignReadOnlyEditor = ({ code, language = 'plaintext' }: ReadOnlyEditorProps) => {
  const editorRef = useRef<monaco.editor.IStandaloneCodeEditor | undefined>(undefined)
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!containerRef.current) return

    const editor = monaco.editor.create(containerRef.current, {
      value: code,
      language,
      readOnly: true,
      minimap: { enabled: false },
      scrollBeyondLastLine: false,
      lineNumbers: 'on',
      fontSize: 14,
      lineHeight: 20,
      padding: { top: 16, bottom: 16 },
      renderLineHighlight: 'none',
      hideCursorInOverviewRuler: true,
      cursorStyle: 'line-thin',
      cursorBlinking: 'solid',
      cursorWidth: 0,
      selectOnLineNumbers: false,
      selectionHighlight: false,
      occurrencesHighlight: false,
      renderWhitespace: 'none',
      contextmenu: false,
      folding: false,
      matchBrackets: 'never',
      bracketPairColorization: {
        enabled: false
      },
      guides: {
        bracketPairs: false,
        highlightActiveBracketPair: false
      }
    })

    editorRef.current = editor

    return () => {
      editor.dispose()
    }
  }, [code, language])

  return (
    <div className="relative rounded-lg border border-gray-200 bg-white w-fit h-fit">
      <div
        ref={containerRef}
        className="min-h-[500px] min-w-[700px] h-fit w-fit overflow-hidden"
        style={{ borderRadius: '8px' }}
      />
      <button
        className="absolute right-3 top-3 p-1.5 text-gray-500 hover:text-gray-700 rounded-md bg-white hover:bg-gray-100 border"
        onClick={() => navigator.clipboard.writeText(code)}
      >
        <FaRegCopy size={24}/>
      </button>
    </div>
  )
}

export default CampaignReadOnlyEditor
